import React from "react";
import Typography, { TypographyProps } from "@mui/material/Typography";
import EmtMarkdown from "./EmtMarkdown"; // Adjust the import path as needed

export type EmtTypographyProps = TypographyProps & {
  nonce?: string;
  onResizeCapture?: any;
  onResize?: any;
  children?: React.ReactNode | string;
};

export const EmtTypography: JSX.Element & any = React.forwardRef<
  HTMLSpanElement,
  EmtTypographyProps
>((componentProps, ref) => {
  const { children, ...rest } = componentProps;

  return (
    <Typography {...rest} ref={ref}>
      {typeof children === "string" ? (
        <EmtMarkdown text={children} />
      ) : (
        children
      )}
    </Typography>
  );
});

EmtTypography.displayName = "EmtTypography";
